var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnYoutub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-hub"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0107 3.18351C16.786 3.38752 17.3909 3.98483 17.6006 4.74761C18.149 6.92374 18.1133 11.038 17.6121 13.2482C17.4048 14.0109 16.7975 14.606 16.0222 14.8122C13.8331 15.3449 4.02838 15.2792 1.96604 14.8122C1.19065 14.6082 0.585777 14.0109 0.376088 13.2482C-0.141226 11.174 -0.10551 6.78774 0.364567 4.75894C0.571945 3.99616 1.17913 3.40113 1.95452 3.19485C4.88096 2.59414 14.9691 2.78795 16.0107 3.18351ZM7.25437 6.3457L11.9551 8.99785L7.25437 11.6501V6.3457Z",
    fill: "#767A7F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnYoutub);
export default __webpack_public_path__ + "static/media/icn_youtub.e345487a558cb9bc9adcc60ae23716df.svg";
export { ForwardRef as ReactComponent };